module.exports = __webpack_public_path__ + "static/43-8993ef4fe6138cbb85d55948e4826ef3.jpg";